const commonConst = () => {
    return {
        noneAddress: "0x0000000000000000000000000000000000000000",
        addressZero: "0x0000000000000000000000000000000000000000",
        addressOne: "0x0000000000000000000000000000000000000001",
        addressE: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        showDecimals: 4,
        ethAddress: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    }
}


const devConst = () => {
    return {
        activeChainId: 97,
        HECOurl: 'http://192.168.1.152:8081',
        // contract address -s
        erc20List: [
            { address: "0x517e18e8b36aef04b5049f2fe3b57246adc19126", symbol: "USDT", decimals: 18, name: "" },
            { address: "0xf0dcfdb9e48f29706abefa440321d11424ac8d50", symbol: "HUSD", decimals: 18, name: "" },
            { address: "0xd534deb99572f49ff56f413b21b99f6070d9c30f", symbol: "FIL", decimals: 18, name: "" },
            // { address: "0xd534deb99572f49ff56f413b21b99f6070d9c30f", symbol: "BFIL", decimals: 18, name: "" },
            // { address: "0x9320af887373f6f8fb9ab1ab0d7641aa2ee52d45", symbol: "IXCH", decimals: 18, name: "" },
            { address: "0xf2593d64263c4ee0d0aa9e59c6010c4fe28ee32a", symbol: "DMC", decimals: 18, name: "" },
            { address: "0x0000000000000000000000000000000000000000", symbol: "DLP", decimals: 18, name: "" },
            { address: "0xb23b00a8b6e0b3cc50fd2fff35df6462e0b3a50a", symbol: "BTC", decimals: 18, name: "" },
            { address: "0xBB78c2ADbf93b4fC9345Bc3bECB38C789C72Bd52", symbol: "BNB", decimals: 18, name: "" },
            // { address: "0x0000000000000000000000000000000000000000", symbol: "DLI", decimals: 18, name: "" },
            // { address: "0x0000000000000000000000000000000000000000", symbol: "LP", decimals: 18, name: "" },
            { address: "0xD9341dcDc9bDC4789185E6e068768B090f43fF26", symbol: "MVT", decimals: 18, name: "" },
        ],
        erc721List: [
            // CloudMiner  CloudPowMiner(V5)
            { address: "0xa7c39db9acc535fb27f347dfb8e58bc300e8b4c9", symbol: "NFT_POWER_V1", name: "DMEX Finance" },
            { address: "0xe8e9d705b9ac7c143c3d00564c2b986a5b0ccf20", symbol: "NFT_POWER_V2", name: "DMEX Finance" },
            { address: "0xf6817ad3555d4fef7f9ae264ec077b59e39eb780", symbol: "NFT_POWER_V5", name: "DMEX Finance" },

            // { address: "0x8535b96087c8a62c64daf0ca4c3f16c8f062fb2c", symbol: "NFT_LEND_V2", name: "DMEX Finance" },
            { address: "0x8e083d6a5cd5c32512cbe0526d305fe06a7bc1c8", symbol: "NFT_LEND_V2", name: "DMEX Finance" },
        ],

        nftMigrateContractAddress: "0x2f091a95e5Ea5976485A3e9880CABAB7956c4F12",
        dmexJointMiningContractAddress: "0xb05f83ba9f5a7a882fa73defb48d566c973f5664",
        dmexJointMiningUpoolContractAddress: "0x826D89Fe2B01F15458B09Add4EBD37232156CFe3",
        hfilPoolPid: "0xe10cddb2405a15b56bdbffbbd601f11f1fe05462f319dac0f89d6fe8adf11e87",
        dmcMiningContractAddress: "0x741555D49Cb2aC44AD7064b267F713aF3435a6a1",

        fPoolFundBackProposalContractAddress: "0xd888a6f0dd0fdfa84a6ab0a0bffdf0552ecd7914",

        fPoolProposalContractAddress: "0x7d2dfa0b931890d87b9594b7ca86ffd23e9f17e3",
        multiSigContractAddress: "0xf6d0af3020c2f455c072ad4c973a7cbe504054ab",


        // dmcMiningContractAddress: "0xdd3886e197dfd0a4e32372a71a31f2fc5750c19a",
        ifil721ContractAddress: "0xa7c39db9acc535fb27f347dfb8e58bc300e8b4c9",
        ifil721V2ContractAddress: "0x824e04f96254ed71f5aa15371c350107c8fc5112",
        // ifil721V3ContractAddress: "0x824e04f96254ed71f5aa15371c350107c8fc5112",
        ifilAbsContractAddress: "0x0000000000000000000000000000000000000000",
        ifilAbsV2ContractAddress: "0x0000000000000000000000000000000000000000",
        ifilJointUContractAddress: "0x18b725813c9bb8cbcd8b8a5d4caf14f4688f0777",
        // DMiner  PowDMiner(V5)
        ifilMiningContractAddress: "0x2e1e8979d54a735317f8f61fb5afdb3e6e26a64f",
        ifilMiningContractAddressV2: "0x79f4a768de7f6e3dcc95a21e0204a6dd69a38e94",
        ifilMiningContractAddressV3: "0xa26126e6881ec0f5707e876fc19a35056401cfe3",
        ifilMiningContractAddressV4: "0x89450d886f4b339a09b06d9533e8d3d1b558c7a7",
        ifilMiningContractAddressV5: "0xf9cbcd764ac80dcf3904cc427a52edb678ac5de5",
        // ifileV4
        ifilNftTradeContractAddress: "0x8516c1082506b27ac91d9cffdfc47431c8ab4d6d",
        ifilNftTradeContractAddressV2: "0x289cdd3f1df82d760fb9886bfa7f86ba51aacda4",
        ifilNftTradeContractAddressV3: "0x289cdd3f1df82d760fb9886bfa7f86ba51aacda4",
        ifilNftTradeSalt: "0x633f542588d153c0839daca378181f998774c69bc3b4cd414173deaa68149694",
        ifilNftV2TradeSalt: "0x633f542588d153c0839daca378181f998774c69bc3b4cd414173deaa68149694",
        ifilNftTradeVersion: "1.0",
        ifilNftV2TradeVersion: "1.0",
        ifilNftTradeName: "CloudMiner Dex",
        ifilNftV2TradeName: "CloudMiner Dex",
        // DMexVendor  DMexPowVendor(V5)
        ifilVendorContractAddress: "0xb6ae1e97e3efa7840aa1143729d39ac7ec20fe3e",
        ifilVendorContractAddressV2: "0x12e988c73de918382d4d25f95decd9fea2e9b830",
        ifilVendorContractAddressV3: "0xacc4478986da0f25d2313ea2c7c0be8bd7cb3b87",
        ifilVendorContractAddressV4: "0x740227070474328fdc5c4a6e6bd4b1be46b6da7c",
        ifilVendorContractAddressV5: "0x2c26379dab3899a800bce031de35ce592028ec99",

        peTimeLockContractAddress: "0xb9612c9fc32821afc090be91c3944857303f3267",
        swapMiningContractAddress: "0x7373c42502874c88954bdd6d50b53061f018422e",
        dmcPoolContractAddress: "0xc6b0f47308613f1bfd1c30208050fcbec98e747e",
        vipPoolContractAddress: "0xe4cf99aee7568561e8bfc4a53cbf0e5901b00692",
        pledgePoolContractAddress: "0x54dbf8e084fa3894c1bfca5c0349c58d4ae236a7",
        // idmexPairContractAddress: "0xb0b670fc1f7724119963018db0bfa86adb22d941",
        idmexPairContractAddress: "0xb7926c0430afb07aa7defde6da862ae0bde767bc",
        // erc20
        usdtContractAddress: "",
        husdContractAddress: "0x93e3f452fba08d9bb44d16f559ad9a9df7153e2b",
        ifilTokenContractAddress: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        ixchTokenContractAddress: '0x9320af887373f6f8fb9ab1ab0d7641aa2ee52d45',
        dmcContractAddress: "0x50a3d9cbb5615ed650ffa48da36ffa5cf82fcd79",

        tokenSwapContractAddress: "0x6df0abfd56702bf1133259902376fbc329984da9",
        dmexAggregatorContractAddress: "",
        rewardPoolContractAddress: "",
        // contract address -e
        // hfilPoolPid: "0x4b25f7952abe0296565bb2e3c6ac3e991710cce6f3ee9d8d1502b834133ca450",
        husdPoolPid: "0xb0751adb163023ebe35722afe322c56fe850c57422df52946f6df0537fa8eac8",
        // dmcPoolPid: "0x4ee81718f34cb1d353a797b17eab621f30bae2877e7c383f43f329ddf4b567bd",
        dmcPoolPid: "0xe69d07c9e6a2e3a9d2175923c34022879798ce4401206cd53be2bcb1eb713bc4",
        vipPoolPid: "0xa585d2371fd8f6d274de0d44f32dccbadec3300115c65ac49104ad50a89ce9e6",
        // fil
        // dmexLendrContractAddress: "0x7365813d3dce9769f76fd711291e3c65c2c82dad",
        dmexLendrContractAddress: "0xeba3ee5521b46e3cccc588e4a3300960bce6bbbe",
        dmexLendrPatchContractAddress: "0xf48e3ad64ba0810b012dfba27ba7403f454f87a8",
        interestPoolContractAddress: "0x9ce4cb6192543d5f2841bde06d671e5da1cce750",
        multiCallContractAddress: "0x8b54247c6bae96a6ccafa468ebae96c4d7445e46",

        currentLockerAddress: "0x39b790Ac0FF4Bba329B6774f850bD4Be4338d620",
        dmcLockerAddress: "0x39b790Ac0FF4Bba329B6774f850bD4Be4338d620",

        fixedLockerAddress: "0xF9378b2609980fc47a6bc897E826Ff6CB70c1DEc",
        dmcMiningTotalAllocPoint: "120",
        powMiningTotalAllocPoint: "",
        posMiningTotalAllocPoint: "",
        liquidityMiningTotalAllocPoint: "30",

        governanceVoteAddress: "0x3125845ce85894b5b6d82cbc47e9bf88c90b1717",

        CommitteeElectProxyAddress: '0x6e2566be84ea8e773c9e2dc8c1ed39b8cf48e5ea',

        ifilSwapContractAddress: "0x61136fa2d46937c6c2a37caafed1b7ae147854e0",
        LockMiningContractAddress: "0xBe606F2107D9e79A85e958E17586D8AC61ea00A0",
        LockUsdtMiningContractAddress: "0x4DeEA12CB29A4F8f7f58872012F91f28C0aC9D44",
        //NFT 质押退币合约
        filPledgeRedeemAddress:"",
        whiteList: [
            "0x577190590e729e0438BFfC67868bD83b3EA5F87C",
            "0x75B8514F194A1Aa417279EF255Fb0d45572B6e7D",
            '0xe419238c8a12A694151e31B6399dF89EA687D062',
            '0xF56bd649c0c775d10d1a9769a29F261DcfBb9F52',
            "0x953E061FEB4d346Cc6Ff5EDa39417eA1F11831b2",
            "0x977d7816D529E8074F016EC70aF816fA3BA068d2",
            '0x8c87b7Abde1111b2f749D70535789A4f577A0Cb8',
            "0x32410b2F76bd1f939F33bc6c1825B40A5611bA69",
            '0x467C3611F8D5e8DD21CBeB42f160a4BDA730E9dC',
            '0xd8901d70F3dAf1B066E018D8c805d14EbA37B6A3',
            '0x69204009e4662f7c2D7675381D3348f6042A8630',
        ],
        signList: [
            "0x577190590e729e0438BFfC67868bD83b3EA5F87C",
            "0x75B8514F194A1Aa417279EF255Fb0d45572B6e7D",
            '0xe419238c8a12A694151e31B6399dF89EA687D062',
            '0xF56bd649c0c775d10d1a9769a29F261DcfBb9F52',
            "0x953E061FEB4d346Cc6Ff5EDa39417eA1F11831b2",
            "0x977d7816D529E8074F016EC70aF816fA3BA068d2",
            '0x8c87b7Abde1111b2f749D70535789A4f577A0Cb8',
            "0x32410b2F76bd1f939F33bc6c1825B40A5611bA69",
            '0x467C3611F8D5e8DD21CBeB42f160a4BDA730E9dC',
            '0xd8901d70F3dAf1B066E018D8c805d14EbA37B6A3',
            '0x69204009e4662f7c2D7675381D3348f6042A8630',
        ],
        miningList: [{
            pid: 0,
            state: 1,
            logo: require("@/assets/images/v2/HFIL.png"),
            name: "F ",
            desc: "DMC/FIL",
            joinPid: "0xe10cddb2405a15b56bdbffbbd601f11f1fe05462f319dac0f89d6fe8adf11e87",
            lpToken: "",
            allocPoint: "0",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
            fromSymbol: "FIL",
            outSymbol: "FIL+DMC",
            apy: "0",
            dpy: "0",
            miningPid: '0xe10cddb2405a15b56bdbffbbd601f11f1fe05462f319dac0f89d6fe8adf11e87',
            type: 1
        },
        {
            pid: -1,
            state: 1,
            logo: require("@/assets/images/v2/USDT.png"),
            name: "U ",
            desc: "FIL",
            joinPid: "0xeb76e33c42afdac1409372c055836dc8854d6f06c04e9bbba53c8bc8b9fb991b",
            lpToken: "",
            allocPoint: "0",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
            fromSymbol: "USDT",
            outSymbol: "FIL",
            apy: "0",
            dpy: "0",
            miningPid: '0xeb76e33c42afdac1409372c055836dc8854d6f06c04e9bbba53c8bc8b9fb991b',
            type: 2
        },
         {
            pid: 0,
            state: 1,
            logo: require("@/assets/images/v2/DMC.png"),
            name: "DMC",
            desc: "DLP/HUSD",
            joinPid: "0x39b790Ac0FF4Bba329B6774f850bD4Be4338d620",
            lpToken: "",
            allocPoint: "0",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
            fromSymbol: "DMC",
            outSymbol: "DMC",
            apy: "0",
            dpy: "0",
            miningPid: '0x39b790Ac0FF4Bba329B6774f850bD4Be4338d620',
            type: 3
        }, ],
        lockMiningList: [{
                pid: 0,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                contractAddress:'',
                poolStatus: ''
            },
            {
                pid: 1,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                contractAddress:'',
                poolStatus: ''
            },
            {
                pid: 2,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                contractAddress:'',
                poolStatus: ''
            },
        ],
        usdtlockMiningList: [{
            pid: 0,
            lockedDays: 0,
            baseApy: 0,
            extraApy: 0,
            poolRemainAmount: 0,
            filAmount: 0,
            dmcAmount: 0,
            availBenefit: 0,
            availDmcAmount: 0,
            maxAmount: 0,
            depositAmount: 0,
            estimateBenefit: 0,
            extraApys: '',
            state: '',
            contractAddress:'',
            poolStatus: ''
        },
        {
            pid: 1,
            lockedDays: 0,
            baseApy: 0,
            extraApy: 0,
            poolRemainAmount: 0,
            filAmount: 0,
            dmcAmount: 0,
            availBenefit: 0,
            availDmcAmount: 0,
            maxAmount: 0,
            depositAmount: 0,
            estimateBenefit: 0,
            extraApys: '',
            state: '',
            contractAddress:'',
            poolStatus: ''
        },
        {
            pid: 2,
            lockedDays: 0,
            baseApy: 0,
            extraApy: 0,
            poolRemainAmount: 0,
            filAmount: 0,
            dmcAmount: 0,
            availBenefit: 0,
            availDmcAmount: 0,
            maxAmount: 0,
            depositAmount: 0,
            estimateBenefit: 0,
            extraApys: '',
            state: '',
            contractAddress:'',
            poolStatus: ''
        },
    ],
        posMiningList: [{
                pid: 3,
                state: 1,
                name: "ZB",
                desc: "HUSD---DMC",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                price: "0",
            },
            {
                pid: 4,
                state: 1,
                name: "ZB",
                desc: "HUSD---DMC",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                price: "0",
            },
            {
                pid: 9,
                state: 1,
                name: "ZB 9",
                desc: "HUSD---DMC",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                price: "0",
            },
            {
                pid: 10,
                state: 1,
                name: "ZB 10",
                desc: "HUSD---DMC",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                price: "0",
            },
        ],
        powMiningList: [{
                pid: 0,
                state: 0,
                logo: require("@/assets/images/usdt_ico.png"),
                name: "ZC",
                desc: "DLP/DMC",
                joinPid: "",
                lpToken: "0xc443db1c86b46c50d2ab48d964606a8a519fb85f",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 1,
                state: 0,
                logo: require("@/assets/images/usdt_ico.png"),
                name: "ZC",
                desc: "DLP/DMC",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 2,
                state: 0,
                logo: require("@/assets/images/usdt_ico.png"),
                name: "ZB",
                desc: "DLP/DMC",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 7,
                state: 0,
                logo: require("@/assets/images/HT.png"),
                name: "ZC",
                desc: "DLP/DMC",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 8,
                state: 1,
                logo: require("@/assets/images/HFIL.png"),
                name: "NONE HFIL POOL",
                desc: "DLP/HFIL",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HFIL",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 11,
                state: 1,
                logo: require("@/assets/images/HUSD.png"),
                name: "NONE HUSD POOL",
                desc: "DLP/HUSD",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 13,
                state: 0,
                logo: require("@/assets/images/HUSD.png"),
                name: "OLD VIP HFIL POOL",
                desc: "DLP/HFIL",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HFIL",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 15,
                state: 1,
                logo: require("@/assets/images/HFIL.png"),
                name: "VIP HFIL POOL",
                desc: "DLP/HFIL",
                joinPid: "",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "HFIL",
                apy: "0",
                dpy: "0",
            }
        ],
        // posMiningList: [{
        //         pid: 3,
        //         state: 1,
        //         name: "ZB",
        //         desc: "HUSD---DMC",
        //         lpToken: "",
        //         allocPoint: "0",
        //         totalReward: "0",
        //         totalToken: "0",
        //         amount: "0",
        //         reward: "0",
        //         from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        //         fromSymbol: "HUSD",
        //         apy: "0",
        //         price: "0",
        //     },
        //     {
        //         pid: 4,
        //         state: 1,
        //         name: "ZB",
        //         desc: "HUSD---DMC",
        //         lpToken: "",
        //         allocPoint: "0",
        //         totalReward: "0",
        //         totalToken: "0",
        //         amount: "0",
        //         reward: "0",
        //         from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        //         fromSymbol: "HUSD",
        //         apy: "0",
        //         price: "0",
        //     },
        //     {
        //         pid: 9,
        //         state: 1,
        //         name: "ZB 9",
        //         desc: "HUSD---DMC",
        //         lpToken: "",
        //         allocPoint: "0",
        //         totalReward: "0",
        //         totalToken: "0",
        //         amount: "0",
        //         reward: "0",
        //         from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        //         fromSymbol: "HUSD",
        //         apy: "0",
        //         price: "0",
        //     },
        //     {
        //         pid: 10,
        //         state: 1,
        //         name: "ZB 10",
        //         desc: "HUSD---DMC",
        //         lpToken: "",
        //         allocPoint: "0",
        //         totalReward: "0",
        //         totalToken: "0",
        //         amount: "0",
        //         reward: "0",
        //         from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        //         fromSymbol: "HUSD",
        //         apy: "0",
        //         price: "0",
        //     },
        // ],
        liquidityMiningList: [
            // {
            //     pid: 17,
            //     state: 1,
            //     logo: require("@/assets/images/v2/IXCH_DMC.png"),
            //     principalsBalance: "0",
            //     lpToken: "0x9320af887373f6f8fb9ab1ab0d7641aa2ee52d45",
            //     allocPoint: "0",
            //     totalReward: "0",
            //     totalToken: "0",
            //     amount: "0",
            //     reward: "0",
            //     from: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
            //     fromPrice: "0.4",
            //     fromSymbol: "IXCH",
            //     to: "0x854bb58fdda85f20b5ab20b20d888f0554c02560",
            //     toPrice: "1",
            //     toSymbol: "DMC",
            //     principalsValue: "0",
            //     dmcValue: "0",
            //     apy: "0",
            // },
            {
                pid: 1,
                state: 1,
                logo: require("@/assets/images/v2/DMC_USDT.png"),
                principalsBalance: "0",
                lpToken: "0x927cea9e5f331d6cfafaa9aeafa3b1c332f4f699",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x517e18e8b36aEF04b5049f2Fe3b57246AdC19126",
                fromPrice: "0.4",
                fromSymbol: "USDT",
                to: "0xf2593D64263C4Ee0D0aA9E59C6010C4Fe28Ee32a",
                toPrice: "1",
                toSymbol: "DMC",
                principalsValue: "0",
                dmcValue: "0",
                apy: "0",
                cnUrl: 'https://www.yuque.com/docs/share/d71e2421-26ea-46c4-be4c-46500b801b52?#',
                enUrl: 'https://dmexservice.gitbook.io/dmex/10-liquidity-mining-on-binance-smart-chain-bsc',
            },
            {
                pid: 2,
                state: 1,
                logo: require("@/assets/images/v2/BNB_DMC.png"),
                principalsBalance: "0",
                lpToken: "0xc6a4EA286A1aa0248b5bcBba17127c28787CFd16",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0xf2593d64263c4ee0d0aa9e59c6010c4fe28ee32a",
                fromPrice: "1",
                fromSymbol: "DMC",
                to: "0xBB78c2ADbf93b4fC9345Bc3bECB38C789C72Bd52",
                toPrice: "0.4",
                toSymbol: "BNB",
                // to: "0xf2593d64263c4ee0d0aa9e59c6010c4fe28ee32a",
                // toPrice: "1",
                // toSymbol: "DMC",
                principalsValue: "0",
                dmcValue: "0",
                apy: "0",
                cnUrl: 'https://www.yuque.com/docs/share/9947e524-0b79-426d-a5e4-abf313735532?#',
                enUrl: 'https://dmexservice.gitbook.io/dmex/10-liquidity-mining-on-binance-smart-chain-bsc',
            },
            // {
            //     pid: 6,
            //     state: 1,
            //     logo: require("@/assets/images/v2/WHT_DMC.png"),
            //     principalsBalance: "0",
            //     lpToken: "0xd8143153f91391a2ec9c584ef9e64eab4df0f9d1",
            //     allocPoint: "0",
            //     totalReward: "0",
            //     totalToken: "0",
            //     amount: "0",
            //     reward: "0",
            //     from: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
            //     fromPrice: "0.4",
            //     fromSymbol: "HT",
            //     to: "0x854bb58fdda85f20b5ab20b20d888f0554c02560",
            //     toPrice: "1",
            //     toSymbol: "DMC",
            //     principalsValue: "0",
            //     dmcValue: "0",
            //     apy: "0",
            // }, {
            //     pid: 8,
            //     state: 1,
            //     logo: require("@/assets/images/v2/IXCH_DMC.png"),
            //     principalsBalance: "0",
            //     lpToken: "0xbdca41005ca25eafa80a3351078742700b511710",
            //     allocPoint: "0",
            //     totalReward: "0",
            //     totalToken: "0",
            //     amount: "0",
            //     reward: "0",
            //     from: "0xfb37dbc6d79e9cb3769c3f83837fbc0277253c95",
            //     fromPrice: "0",
            //     fromSymbol: "IXCH",
            //     to: "0x854bb58fdda85f20b5ab20b20d888f0554c02560",
            //     toPrice: "0",
            //     toSymbol: "DMC",
            //     principalsValue: "0",
            //     dmcValue: "0",
            //     apy: "0",
            // },
        ],

        zhongqiuList: [
            '0x038bb98b11278659d5b34c1273e150d650b47bd1',
            '0x0424466c6c78b7710335abf8759c4631930855d4',
            '0x04426de87af36eeb190a6f363870eba57106290a',
            '0x0852ad8694b1627c11229786affd055b26d09ae2',
            '0x0e1ac7095bdcad5e987d00e65f76098332dcda1d',
            '0x255eedc4d05ab946adfd8ae218a0cb0172754508',
            '0x3d095f92152a37c6b0e84707d48080c807126a2c',
            '0x723d38bcef72f56cc2e580e053b2a52ec8bb415f',
            '0x81da74335fc4b92c7c171149d4c3d4424f60c3a8',
            '0x8baa4a11aaec3eb2e8eb4fea2701c9728e0623dd',
            '0x982391038b5733cfc8e9668bc1d7034f10ed1b97',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0xa19ac8bdc277bfedd82148b610dac94afffa8267',
            '0xa51e04821b461fd13a0d0acf6ef5df87606642d3',
            '0xbbf6b3393865bbf4bafbe8c9df1c60ccf2cab318',
            '0xbfd65cfdce894fc0a1a72e976ac014d262ba5d2f',
            '0xeb54bd7db95b699252cad79a396f0ac9cade99ab',

            '0x9382401f5ebf8d04d216d704770293b29255bb78',
            '0xcbdf84df7efef736a4aad4269e002c995f014f8d',
            '0xbbf6b3393865bbf4bafbe8c9df1c60ccf2cab318',
            '0x670df46c8651ee6760cdf184407097e2e8596256',
            '0x755eecd135a5c0d07edbe98f6a9a5e6743ff6ba1',
            '0xca6a430e64ae64124bd8f9efe77bc0a5437bbe1c',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0x12083aa5be1ec9b2cca39e447e96b74593dbf32f',
            '0x0852ad8694b1627c11229786affd055b26d09ae2',
            '0x13a96cb12d0c12d086a86889ebd9fc87f8595826',
            '0xa6bb086bc0de4bb7685580ebdf4e9c1164b80cec',
            '0x2c27f522a71774774ef5c98ced8b6ef83fd9f866',
            '0x460adc7761d27a080e591f6c2e20cfd2f7264dfe',
            '0xa297d9096f41818676fd1175bbbf04f88a724514',
            '0x1c8b2fd6e02397b15e4f7fea84219bf69b41011d',
            '0x556e5149daa79dd736283090b3168c718a1d57a0',

            '0x0940eb43186743aa6e12d3e07855792bd5f46770',
            '0x255eedc4d05ab946adfd8ae218a0cb0172754508',
            '0x6374ea609c3bcc4e35064b41d0d365ab6e3ab82e',
            '0x670df46c8651ee6760cdf184407097e2e8596256',
            '0x6accc165e5cfacc71ae4c5acfd3a66fd50e5d3d4',
            '0x98f090e436e74b8b3095a2e0b715f381b04aa774',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0xa73558c94cbdb42ef189e68c9d993d252f6f252b',
            '0xcbdf84df7efef736a4aad4269e002c995f014f8d',
        ],
        hashUrlList: [
            { symbol: 'BFIL', url: 'https://testnet.bscscan.com/tx/' },
            { symbol: 'FIL', url: 'https://calibration.filscan.io/tipset/message-detail?cid=' },
            { symbol: 'BSC', url: 'https://testnet.bscscan.com/tx/' },
        ]
    }
}


const testConst = () => {
    return {
        activeChainId: 97,
        HECOurl: 'http://192.168.1.152:8081',
        // contract address -s
        nftMigrateContractAddress: "0x0000000000000000000000000000000000000000",
        dmcMiningContractAddress: "0xdd3886e197dfd0a4e32372a71a31f2fc5750c19a",
        ifil721ContractAddress: "0xa7c39db9acc535fb27f347dfb8e58bc300e8b4c9",
        ifil721V2ContractAddress: "0xacd8fea106ce1572b4090b933a0f29a2e854828b",
        ifilAbsContractAddress: "0x0000000000000000000000000000000000000000",
        ifilAbsV2ContractAddress: "0x0000000000000000000000000000000000000000",
        ifilJointUContractAddress: "0x18b725813c9bb8cbcd8b8a5d4caf14f4688f0777",
        ifilMiningContractAddress: "0x2e1e8979d54a735317f8f61fb5afdb3e6e26a64f",
        ifilMiningContractAddressV2: "0x9bf39d3c0af8644d74384b7e6a7e6c4f7de1f0a7",
        ifilNftTradeContractAddress: "0x8516c1082506b27ac91d9cffdfc47431c8ab4d6d",
        ifilNftTradeContractAddressV2: "0x17f8e0e815af992b25eceec4e743994983d9af62",
        ifilNftTradeContractAddressV3: "",
        ifilNftTradeSalt: "0x633f542588d153c0839daca378181f998774c69bc3b4cd414173deaa68149694",
        ifilNftV2TradeSalt: "0x633f542588d153c0839daca378181f998774c69bc3b4cd414173deaa68149694",
        ifilNftTradeVersion: "1.0",
        ifilNftV2TradeVersion: "1.0",
        ifilNftTradeName: "CloudMiner Dex",
        ifilNftV2TradeName: "CloudMiner Dex",
        ifilTokenContractAddress: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
        ifilVendorContractAddress: "0xb6ae1e97e3efa7840aa1143729d39ac7ec20fe3e",
        ifilVendorContractAddressV2: "0x45dbbe0dc5e903c28d8148e42f2df3b7993f4553",
        usdtContractAddress: "",
        husdContractAddress: "0x93e3f452fba08d9bb44d16f559ad9a9df7153e2b",
        peTimeLockContractAddress: "0xb9612c9fc32821afc090be91c3944857303f3267",
        swapMiningContractAddress: "0x0000000000000000000000000000000000000000",
        idmexPairContractAddress: "0x0000000000000000000000000000000000000000",
        dmcPoolContractAddress: "0x6f512e89148b1380d506eaca6a3c019e5ac1f451",
        vipPoolContractAddress: "0x424ac21b1fa9c8e7334dc5414833b2b2762f96f2",
        // erc20
        dmcContractAddress: "0x50a3d9cbb5615ed650ffa48da36ffa5cf82fcd79",
        ixchTokenContractAddress: '0xfb37dbc6d79e9cb3769c3f83837fbc0277253c95',
        tokenSwapContractAddress: "0x6df0abfd56702bf1133259902376fbc329984da9",

        currentLockerAddress: "",

        fixedLockerAddress: "",
        dmexAggregatorContractAddress: "",
        rewardPoolContractAddress: "",

        fPoolProposalContractAddress: "",
        multiSigContractAddress: "",
        //NFT 质押退币合约
        filPledgeRedeemAddress:"",
        // contract address -e
        hfilPoolPid: "0x89a2985c16ccdc298304781aa33a9f46060b6d28442352231286dcc82090e2bd",
        husdPoolPid: "",
        dmcPoolPid: "",
        powMiningList: [{
            pid: 2,
            name: "ZB",
            desc: "btoken/DMC",
            totalReward: "0",
        }, ],
        posMiningList: [{
            pid: 3,
            name: "ZB",
            desc: "HUSD---DMC",
            totalReward: "0",
            apy: "0",
        }, ],
        liquidityMiningList: [{
            pid: 5,
            logo: require("@/assets/images/usdt_ico.png"),
            principalsBalance: "0",
            name: "ZB",
            desc: " DMC/HUSD LP",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            lpToken: "",
            apy: "0.1",
            price: "0.4",
        }, ]
    }
}


const prodConst = () => {
    return {
        activeChainId: 56,
        HECOurl: 'https://ht.dmex.im',
        //HECOurl: 'http://192.168.1.152:8081',
        // contract address -s
        erc20List: [
            { address: "0x55d398326f99059ff775485246999027b3197955", symbol: "USDT", decimals: 18, name: "" },
            { address: "0x55d398326f99059ff775485246999027b3197955", symbol: "BUSD", decimals: 18, name: "" },
            { address: "0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153", symbol: "FIL", decimals: 18, name: "" },
            { address: "0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153", symbol: "BFIL", decimals: 18, name: "" },
            { address: "0xa5342d72d04c133180f376753f90a4b2eee29bb3", symbol: "DMC", decimals: 18, name: "" },
            { address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c", symbol: "BTC", decimals: 18, name: "" },
            { address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c", symbol: "BNB", decimals: 18, name: "" },
            // { address: "0xa71edc38d189767582c38a3145b5873052c3e47a", symbol: "USDT", decimals: 18, name: "Heco-Peg USDTHECO Token" },
            // { address: "0x0298c2b32eae4da002a15f36fdf7615bea3da047", symbol: "HUSD", decimals: 8, name: "Heco-Peg HUSD Token" },
            // { address: "0xae3a768f9ab104c69a7cd6041fe16ffa235d1810", symbol: "HFIL", decimals: 18, name: "Heco-Peg HFIL Token" },
            // { address: "0xfb37dbc6d79e9cb3769c3f83837fbc0277253c95", symbol: "IXCH", decimals: 18, name: "IXCH TOKEN" },
            // { address: "0x854bb58fdda85f20b5ab20b20d888f0554c02560", symbol: "DMC", decimals: 18, name: "Decentralized Mining Coin" },
            // { address: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f", symbol: "WHT", decimals: 18, name: "Wrapped HT" },
            { address: "0x0000000000000000000000000000000000000000", symbol: "DLP", decimals: 18, name: "" },
            // { address: "0x0000000000000000000000000000000000000000", symbol: "DLI", decimals: 18, name: "" },
            // { address: "0x0000000000000000000000000000000000000000", symbol: "LP", decimals: 18, name: "" },
            // { address: "0xddfa9c3d2b9ab6e3c59de26653bdd2cea22ed169", symbol: "MVT", decimals: 18, name: "" },
        ],
        erc721List: [
            { address: "0x7dda78646ac44b2b1eb9b67aa74b0ebcda1839e0", symbol: "NFT_POWER_V1", name: "DMEX Finance" },
            { address: "0x2584abf5a6d66947a651ece9db2a3056af7c3727", symbol: "NFT_POWER_V2", name: "DMEX Finance" },
            { address: "0x582537195b1e21354e0ab1edb9d11b119a9ef8ff", symbol: "NFT_POWER_V5", name: "DMEX Finance" },

            { address: "0x50a7754a35c5630d9e76d765ac2501331c4c5672", symbol: "NFT_LEND_V2", name: "DMEX Finance" },
        ],
        // BSC
        nftMigrateContractAddress: "0x9e79E9c3e4773bB57E950c850ca2B6dbd59C5b8a",
        dmexJointMiningContractAddress: "0x7f4b2cb5c94a3618a4d77113c082e82a07da0553",
        dmexJointMiningUpoolContractAddress: "0x9B3Caa73d120370F102377Ac164319C6e75D614A",
        dmcMiningContractAddress: "0x2d95c5388289602d71752a458661b884631085e9",
        hfilPoolPid: "0xa8abf4fb7bd5a989523772ad1dd63bd351fda9aebec215fdf377fb80f8b7dd5d",

        fPoolFundBackProposalContractAddress: "0x0a6cb6f5ba0ac22f2289e5c0e2d34f1b52cbf046",

        fPoolProposalContractAddress: "",
        multiSigContractAddress: "0x7b6148291f6e2ca8eb587d268146761776a5a19e",


        //dmcMiningContractAddress: "0x9cbf674532e0873b439619b3ca9c8e32688e5a99",
        ifil721ContractAddress: "0x7dda78646ac44b2b1eb9b67aa74b0ebcda1839e0",
        ifil721V2ContractAddress: "0x36ca8eaf6eaa1c4fa1c5fc62bf0b8acd45ef55ec",
        ifilAbsContractAddress: "0x0000000000000000000000000000000000000000",
        ifilAbsV2ContractAddress: "",
        ifilJointUContractAddress: "0xac5225eead90c37165e4364970b147cbedcd52d2",
        ifilMiningContractAddress: "0xc5cc00daa098993db10e3d2959d3b2952d0f1741",
        ifilMiningContractAddressV2: "0xd20b8d9bd466403853a888cecabdebd0a9232f93",
        ifilMiningContractAddressV3: "",
        ifilMiningContractAddressV4: "0x1d43b04a55d27c46fb5048d91b8b55b9621ddbe8",
        ifilMiningContractAddressV5: "0xffb2bc2d2682ffa6b83dcf383df237df31b0c7fd",


        ifilNftTradeContractAddress: "0x8ff9eaabdf9424fc17934bf186fabb9fce303730",
        ifilNftTradeContractAddressV2: "0x1485a9a1b40e5abe79dc249443e354126480f1a1",
        ifilNftTradeSalt: "0x3a57ef911e7e271df30e8aee1209724c8e2cd9ea4c9242162fe23bee8a9e5d74",
        ifilNftV2TradeSalt: "0x3a57ef911e7e271df30e8aee1209724c8e2cd9ea4c9242162fe23bee8a9e5d74",
        ifilNftTradeVersion: "1.0",
        ifilNftV2TradeVersion: "1.0",
        ifilNftTradeName: "CloudMiner Dex",
        ifilNftV2TradeName: "CloudMiner Dex",
        ifilVendorContractAddress: "0x5a65d56a86d94bcb24d8ce8b5ed0319a3754d6b2",
        ifilVendorContractAddressV2: "0x0fb8d08a7e3090c1f1b6cdd55d345024605e0f26",
        ifilVendorContractAddressV3: "0x4e6b53834a94ca84add3f3ab96ce78836d2ac5e2",
        ifilVendorContractAddressV4: "0x37649d01953e9db78d824c3d0901252ffdc19278",
        ifilVendorContractAddressV5: "0xc7316a37f610bacd14cb7a0e704457dadf750e78",

        peTimeLockContractAddress: "0x437d6b5d91a4fde1959213ac14168e2495609a7a",
        swapMiningContractAddress: "0x7373c42502874c88954bdd6d50b53061f018422e",
        idmexPairContractAddress: "0xca143ce32fe78f1f7019d7d551a6402fc5350c73",
        dmcPoolContractAddress: "0x66a40dac4c59199671762865b8e430a37303132d",
        vipPoolContractAddress: "",
        // erc20
        ifilTokenContractAddress: "0xae3a768f9ab104c69a7cd6041fe16ffa235d1810",
        usdtContractAddress: "0xa71edc38d189767582c38a3145b5873052c3e47a",
        husdContractAddress: "0x0298c2b32eae4da002a15f36fdf7615bea3da047",
        dmcContractAddress: "0x854bb58fdda85f20b5ab20b20d888f0554c02560",
        whtContractAddress: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
        ixchTokenContractAddress: '0xfb37dbc6d79e9cb3769c3f83837fbc0277253c95',

        tokenSwapContractAddress: "0xb81c88be2c14e16f5b8db2040b355a4714bef971",
        // dmexAggregatorContractAddress: "0xd89226d552b3e29cff9616f53140da7e47de8b11", //--- old
        dmexAggregatorContractAddress: "0xc4Daec391f8eFEf0AAB5d5F2a761Ec6C186038A2",
        rewardPoolContractAddress: "0x4d91cf409786e81753a8dccd6f1517c593d00e67",
        // fil
        dmexLendrContractAddress: "0xf3c7f3003129a6c659c997c73ed3be25797379dc",
        multiCallContractAddress: "0x1ee38d535d541c55c9dae27b12edf090c608e6fb",

        currentLockerAddress: "0xbf162e8ba1b1fa87647e9055fb87915f2d003cd2",
        dmcLockerAddress: "0xbf162e8ba1b1fa87647e9055fb87915f2d003cd2",

        fixedLockerAddress: "0x52bc4dc385c9baea1eb73f600efdec9fd102fdd5",
        // contract address -e
        // hfilPoolPid: "0x55d81d93f7b4b4bcdf28e786911b77ace18ec7c754f0024bf079260eb4f24f65",
        husdPoolPid: "0x7d6ac652bf22bfd9acef39a5752f71e50af40ea21768080676465453284fc069",
        dmcPoolPid: "0x48f5a284c8ba83254aef43d9a7d1f2b02300330d0fa06356b3e5a2864950d305",
        vipPoolPid: "",

        // fPoolProposalContractAddress: "0xc4ebb40267aa41d25dd180270fa6cffb55c39c18",
        // multiSigContractAddress: "0xaabb629bd71bcf139f637723fcf474616eef4506",
        ifilSwapContractAddress: "0x49D3149B481A787C9bEcE85F67A0e8b9E9679294",
        LockMiningContractAddress: "0x6a97d1873c226b1a0719e25a0a79af3d94220eda",
        LockUsdtMiningContractAddress: "0x92ead9b1ef70592fd6e6332bd22b59e0f6ebbef1",
      //NFT 质押退币合约
        filPledgeRedeemAddress:"0xC9dE33cC596C613D23A2962F219602401fB5C6B9",
        whiteList: [
            '0x0144eDf8DDBccD66ddc5cC9075a6e2Cfa937b8dE',
            '0x948A9d36e499Be1658Ae431B1Ce78371c9898B9c',
            '0x956afa771770668f34e36363cb24d1658ee6ec6e',
            '0x0074aC698Ce7DA0bFA4990a2D62655d7387a031A',
            '0xA73558c94cBDB42eF189E68C9D993D252f6F252B',
            "0x577190590e729e0438BFfC67868bD83b3EA5F87C"
        ],
        signList: [
            "0x0074aC698Ce7DA0bFA4990a2D62655d7387a031A",
        ],
        lockMiningList: [{
                pid: 0,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                poolStatus: ''
            },
            {
                pid: 1,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                poolStatus: ''
            },
            {
                pid: 2,
                lockedDays: 0,
                baseApy: 0,
                extraApy: 0,
                poolRemainAmount: 0,
                filAmount: 0,
                dmcAmount: 0,
                availBenefit: 0,
                availDmcAmount: 0,
                maxAmount: 0,
                depositAmount: 0,
                estimateBenefit: 0,
                extraApys: '',
                state: '',
                poolStatus: ''
            },
        ],
        usdtlockMiningList: [{
            pid: 0,
            lockedDays: 0,
            baseApy: 0,
            extraApy: 0,
            poolRemainAmount: 0,
            filAmount: 0,
            dmcAmount: 0,
            availBenefit: 0,
            availDmcAmount: 0,
            maxAmount: 0,
            depositAmount: 0,
            estimateBenefit: 0,
            extraApys: '',
            state: '',
            contractAddress:'',
            poolStatus: ''
        },
        {
            pid: 1,
            lockedDays: 0,
            baseApy: 0,
            extraApy: 0,
            poolRemainAmount: 0,
            filAmount: 0,
            dmcAmount: 0,
            availBenefit: 0,
            availDmcAmount: 0,
            maxAmount: 0,
            depositAmount: 0,
            estimateBenefit: 0,
            extraApys: '',
            state: '',
            contractAddress:'',
            poolStatus: ''
        }
    ],
        miningList: [{
                pid: 0,
                state: 1,
                logo: require("@/assets/images/v2/HFIL.png"),
                name: "F",
                desc: "DLP/HFIL",
                joinPid: "0xa8abf4fb7bd5a989523772ad1dd63bd351fda9aebec215fdf377fb80f8b7dd5d",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "FIL",
                outSymbol: "FIL+DMC",
                apy: "0",
                dpy: "0",
                miningPid: '0xa8abf4fb7bd5a989523772ad1dd63bd351fda9aebec215fdf377fb80f8b7dd5d',
                type: 1
            },
            {
                pid: -1,
                state: 1,
                logo: require("@/assets/images/v2/USDT.png"),
                name: "U ",
                desc: "FIL",
                joinPid: "0x707887aa96a23773fce627bd247c6b0826fd2d196c4c01e1ea20be3de90de065",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "USDT",
                outSymbol: "FIL",
                apy: "0",
                dpy: "0",
                miningPid: '0x707887aa96a23773fce627bd247c6b0826fd2d196c4c01e1ea20be3de90de065',
                type: 2
            },
            {
                pid: 0,
                state: 1,
                logo: require("@/assets/images/v2/DMC.png"),
                name: "DMC",
                desc: "DLP/HUSD",
                joinPid: "0xbf162e8ba1b1fa87647e9055fb87915f2d003cd2",
                lpToken: "",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x5440a571f46b1e1a15975b584bcd126925409b0c",
                fromSymbol: "DMC",
                outSymbol: "DMC",
                apy: "0",
                dpy: "0",
                miningPid: '0xbf162e8ba1b1fa87647e9055fb87915f2d003cd2',
                type: 3
            },
        ],

        powMiningList: [{
                pid: 3,
                state: 1,
                logo: require("@/assets/images/HFIL.png"),
                name: "NONE HFIL POOL",
                desc: "DLP/HFIL",
                joinPid: "0x55d81d93f7b4b4bcdf28e786911b77ace18ec7c754f0024bf079260eb4f24f65",
                lpToken: "0x7dbd82ca3b656c58768473838401e054f0ec4553",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0xae3a768f9ab104c69a7cd6041fe16ffa235d1810",
                fromSymbol: "HFIL",
                apy: "0",
                dpy: "0",
            },
            {
                pid: 4,
                state: 1,
                logo: require("@/assets/images/HUSD.png"),
                name: "NONE HUSD POOL",
                desc: "DLP/HUSD",
                joinPid: "0x7d6ac652bf22bfd9acef39a5752f71e50af40ea21768080676465453284fc069",
                lpToken: "0x45b2080bcd138714e44e151e16149875be3eaa2d",
                allocPoint: "0",
                totalReward: "0",
                totalToken: "0",
                amount: "0",
                reward: "0",
                from: "0x0298c2b32eae4da002a15f36fdf7615bea3da047",
                fromSymbol: "HUSD",
                apy: "0",
                dpy: "0",
            },
        ],
        posMiningList: [],
        liquidityMiningList: [{
            pid: 1,
            state: 1,
            logo: require("@/assets/images/v2/DMC_USDT.png"),
            principalsBalance: "0",
            lpToken: "0x9b10fb0fa6661fbe8263d2a0555f69f5dd35f4bb",
            allocPoint: "0",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            from: "0xa5342d72d04c133180f376753f90a4b2eee29bb3",
            fromPrice: "0",
            fromSymbol: "DMC",
            to: "0x55d398326f99059ff775485246999027b3197955",
            toPrice: "0",
            toSymbol: "USDT",
            principalsValue: "0",
            dmcValue: "0",
            apy: "0",
            cnUrl: 'https://www.yuque.com/docs/share/d71e2421-26ea-46c4-be4c-46500b801b52?#',
            enUrl: 'https://dmexservice.gitbook.io/dmex/10-liquidity-mining-on-binance-smart-chain-bsc',
        }, {
            pid: 2,
            state: 1,
            logo: require("@/assets/images/v2/BNB_DMC.png"),
            principalsBalance: "0",
            lpToken: "0x0865dedbd99c622e2dd1b7ce6c51eec2a7b8c035",
            allocPoint: "0",
            totalReward: "0",
            totalToken: "0",
            amount: "0",
            reward: "0",
            from: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
            fromPrice: "0.4",
            fromSymbol: "DMC",
            to: "0xa5342d72d04c133180f376753f90a4b2eee29bb3",
            toPrice: "1",
            toSymbol: "WBNB",
            principalsValue: "0",
            dmcValue: "0",
            apy: "0",
            cnUrl: 'https://www.yuque.com/docs/share/9947e524-0b79-426d-a5e4-abf313735532?#',
            enUrl: 'https://dmexservice.gitbook.io/dmex/10-liquidity-mining-on-binance-smart-chain-bsc',
        }],
        zhongqiuList: [
            '0x038bb98b11278659d5b34c1273e150d650b47bd1',
            '0x0424466c6c78b7710335abf8759c4631930855d4',
            '0x04426de87af36eeb190a6f363870eba57106290a',
            '0x0852ad8694b1627c11229786affd055b26d09ae2',
            '0x0e1ac7095bdcad5e987d00e65f76098332dcda1d',
            '0x255eedc4d05ab946adfd8ae218a0cb0172754508',
            '0x3d095f92152a37c6b0e84707d48080c807126a2c',
            '0x723d38bcef72f56cc2e580e053b2a52ec8bb415f',
            '0x81da74335fc4b92c7c171149d4c3d4424f60c3a8',
            '0x8baa4a11aaec3eb2e8eb4fea2701c9728e0623dd',
            '0x982391038b5733cfc8e9668bc1d7034f10ed1b97',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0xa19ac8bdc277bfedd82148b610dac94afffa8267',
            '0xa51e04821b461fd13a0d0acf6ef5df87606642d3',
            '0xbbf6b3393865bbf4bafbe8c9df1c60ccf2cab318',
            '0xbfd65cfdce894fc0a1a72e976ac014d262ba5d2f',
            '0xeb54bd7db95b699252cad79a396f0ac9cade99ab',

            '0x9382401f5ebf8d04d216d704770293b29255bb78',
            '0xcbdf84df7efef736a4aad4269e002c995f014f8d',
            '0xbbf6b3393865bbf4bafbe8c9df1c60ccf2cab318',
            '0x670df46c8651ee6760cdf184407097e2e8596256',
            '0x755eecd135a5c0d07edbe98f6a9a5e6743ff6ba1',
            '0xca6a430e64ae64124bd8f9efe77bc0a5437bbe1c',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0x12083aa5be1ec9b2cca39e447e96b74593dbf32f',
            '0x0852ad8694b1627c11229786affd055b26d09ae2',
            '0x13a96cb12d0c12d086a86889ebd9fc87f8595826',
            '0xa6bb086bc0de4bb7685580ebdf4e9c1164b80cec',
            '0x2c27f522a71774774ef5c98ced8b6ef83fd9f866',
            '0x460adc7761d27a080e591f6c2e20cfd2f7264dfe',
            '0xa297d9096f41818676fd1175bbbf04f88a724514',
            '0x1c8b2fd6e02397b15e4f7fea84219bf69b41011d',
            '0x556e5149daa79dd736283090b3168c718a1d57a0',

            '0x0940eb43186743aa6e12d3e07855792bd5f46770',
            '0x255eedc4d05ab946adfd8ae218a0cb0172754508',
            '0x6374ea609c3bcc4e35064b41d0d365ab6e3ab82e',
            '0x670df46c8651ee6760cdf184407097e2e8596256',
            '0x6accc165e5cfacc71ae4c5acfd3a66fd50e5d3d4',
            '0x98f090e436e74b8b3095a2e0b715f381b04aa774',
            '0x9dde536b75f2128fadf1c0cd8ef8490924c54669',
            '0xa73558c94cbdb42ef189e68c9d993d252f6f252b',
            '0xcbdf84df7efef736a4aad4269e002c995f014f8d',
        ],
        hashUrlList: [
            { symbol: 'BFIL', url: 'https://bscscan.com/tx/' },
            { symbol: 'FIL', url: 'https://filfox.info/zh/message/' },
            { symbol: 'BSC', url: 'https://bscscan.com/tx/' },
        ]

    }
}

const getBizConst = () => {
   //return devConst();
    return prodConst();

    if (process.env.NODE_ENV == 'production') {

        let HOST = process.env.HOST;
        if (!!HOST && "test" == HOST.toLowerCase()) {
            return testConst();
        } else {
            return prodConst();
        }
    } else {
        return devConst();
    }
}

export default {
    ...commonConst(),
    ...getBizConst(),
}



// WEBPACK FOOTER //
// ./src/models/bizConfig.js